<template>
    <BreadCrumb PageTitle="Mon Agenda" />
    <MonAgenda />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import MonAgenda from "../../components/EmploiDuTemps/MonAgenda.vue";
  
    export default defineComponent({
      name: "MonAgendaPage",
      components: {
        BreadCrumb,
        MonAgenda,
      },
    });
  </script>